/**
 * @generated SignedSource<<d288154b504e751d0911ea061e7175b8>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "runningScheduleModel"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "sortOrder": "ASC"
            }
        }
    ], v2 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
        }
    ], v3 = {
        "kind": "Variable",
        "name": "model",
        "variableName": "runningScheduleModel"
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleIndexPageQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "runningScheduleModel",
                            "variableName": "runningScheduleModel"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ScheduleGrid_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleIndexPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ScheduleConnection",
                    "kind": "LinkedField",
                    "name": "schedules",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Schedule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "archived",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "inactivatedFrom",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "assignmentTypes",
                                            "plural": false,
                                            "selections": (v2 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "assignedEntityId": {
                                                            "neq": null
                                                        }
                                                    }
                                                }
                                            ],
                                            "concreteType": "ScheduleShiftConnection",
                                            "kind": "LinkedField",
                                            "name": "runningSchedule",
                                            "plural": false,
                                            "selections": (v2 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                (v3 /*: any*/)
                                            ],
                                            "concreteType": "ScheduleShiftChangeRequestConnection",
                                            "kind": "LinkedField",
                                            "name": "shiftChangeRequests",
                                            "plural": false,
                                            "selections": (v2 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": "vacantShifts",
                                            "args": [
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "assignedEntityId": {
                                                            "eq": null
                                                        }
                                                    }
                                                }
                                            ],
                                            "concreteType": "ScheduleShiftConnection",
                                            "kind": "LinkedField",
                                            "name": "runningSchedule",
                                            "plural": false,
                                            "selections": (v2 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": "schedulableAssets",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "type": {
                                                            "eq": "ASSET"
                                                        }
                                                    }
                                                }
                                            ],
                                            "concreteType": "SchedulableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "schedulableEntities",
                                            "plural": false,
                                            "selections": (v2 /*: any*/),
                                            "storageKey": "schedulableEntities(where:{\"type\":{\"eq\":\"ASSET\"}})"
                                        },
                                        {
                                            "alias": "schedulableUser",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "type": {
                                                            "eq": "USER"
                                                        }
                                                    }
                                                }
                                            ],
                                            "concreteType": "SchedulableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "schedulableEntities",
                                            "plural": false,
                                            "selections": (v2 /*: any*/),
                                            "storageKey": "schedulableEntities(where:{\"type\":{\"eq\":\"USER\"}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "schedules(first:50,order:{\"sortOrder\":\"ASC\"})"
                },
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "ScheduleGrid_query_schedules",
                    "kind": "LinkedHandle",
                    "name": "schedules"
                }
            ]
        },
        "params": {
            "cacheID": "7284e7bc48c3c193921447f76124b947",
            "id": null,
            "metadata": {},
            "name": "ScheduleIndexPageQuery",
            "operationKind": "query",
            "text": "query ScheduleIndexPageQuery(\n  $runningScheduleModel: GetRunningScheduleRequestInput!\n) {\n  ...ScheduleGrid_query_1gb8Rr\n}\n\nfragment ScheduleCard_schedule_1gb8Rr on Schedule {\n  archived\n  inactivatedFrom\n  assignmentTypes {\n    totalCount\n  }\n  id\n  name\n  runningSchedule(model: $runningScheduleModel, where: {assignedEntityId: {neq: null}}) {\n    totalCount\n  }\n  shiftChangeRequests(model: $runningScheduleModel) {\n    totalCount\n  }\n  vacantShifts: runningSchedule(model: $runningScheduleModel, where: {assignedEntityId: {eq: null}}) {\n    totalCount\n  }\n  schedulableAssets: schedulableEntities(where: {type: {eq: ASSET}}) {\n    totalCount\n  }\n  schedulableUser: schedulableEntities(where: {type: {eq: USER}}) {\n    totalCount\n  }\n}\n\nfragment ScheduleGrid_query_1gb8Rr on Query {\n  schedules(first: 50, order: {sortOrder: ASC}) {\n    edges {\n      node {\n        ...ScheduleCard_schedule_1gb8Rr\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "43b659d45879f87cd56a98a9c65a6662";
export default node;
